<!-- Простий блок з інформацією про пацієнта -->
<div class="patient-info mb-3" *ngIf="patient">
  <div class="alert alert-info d-flex align-items-center mb-0">
    <i class="bi bi-person-circle fs-4 me-3 text-primary"></i>
    <div>
      <h6 class="mb-0 fw-bold">{{ patient.firstName }} {{ patient.lastName }}</h6>
      <small class="text-muted">{{ 'current_patient' | transloco }}</small>
    </div>
  </div>
</div>

<!-- Повідомлення про відсутність пацієнта -->
<div class="alert alert-warning d-flex align-items-center" *ngIf="!patient">
  <i class="bi bi-exclamation-triangle me-2"></i>
  <span>{{ 'patient_not_selected' | transloco }}</span>
</div>
<app-sub-navbar [routes]="routes"></app-sub-navbar>
<router-outlet></router-outlet>
